<template>
  <v-container fluid style="min-width: 450px">
    <v-toolbar>
      <v-toolbar-title>{{ $t('Consumables') }}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-btn-toggle v-model="screen" class="transparent">
        <v-tooltip bottom>
          <v-btn slot="activator" flat value="products" @click="$router.push('/consumables/products')">
            <v-icon left>storage</v-icon>
            {{ $t('Products') }}
          </v-btn>
          <span>{{ $t('Products') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn slot="activator" flat value="orders" @click="$router.push('/consumables/orders')">
            <v-icon left>outbox</v-icon>
            {{ $t('Orders') }}
          </v-btn>
          <span>{{ $t('Orders') }}</span>
        </v-tooltip>
      </v-btn-toggle>

      <v-spacer></v-spacer>

    </v-toolbar>

    <v-card>
      <v-card-text>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'consumables',
  data() {
    return {
      screen: ''
    }
  },
  methods: {
    screenType() {
      let p = this.$route.path.lastIndexOf('/');
      if (!!p && p > 0) {
        return this.$route.path.substring(p + 1);
      }
      return '';
    }
  },
  mounted() {
    this.screen = this.screenType();
  }
}
</script>
